module.exports = __webpack_public_path__ + "static/media/LI.14467e6d.png";